import {
  put, takeLatest, takeEvery, select, all,
} from 'redux-saga/effects';
import {
  TeammoApi,
  normalize,
  // compilePaginationObject,
} from 'app/utils/redux/helpers';
import history from 'app/routes/history';
import { userSchema } from 'app/utils/redux/schemas';
import { handleError } from 'app/utils/handlers/handleError';
// import { loadingStart, loadingFinish } from 'app/ducks/loading/actions';
import { sagaActions } from 'app/ducks/users/actions';
import { UsersActionTypes as types } from 'app/ducks/users/types';

function* createUserSaga(action): any {
  yield put(sagaActions.createUserPending(action.payload));
  const [error, response] = yield (yield TeammoApi(yield select())).users.create(
    action.payload,
  );

  if (response) {
    const normalizedResponse = normalize(response, userSchema);

    yield put(sagaActions.createUserSuccess(normalizedResponse));
  } else {
    yield put(
      handleError(
        error,
        sagaActions.createUserFailed(_.isEmpty(error) ? {} : error.response.data.errors),
      ),
    );
  }
}

function* updateUserSaga(action): any {
  yield put(sagaActions.updateUserPending(action.payload));
  const [error, response] = yield (yield TeammoApi(yield select())).users.update(
    action.payload,
  );

  if (response) {
    const normalizedResponse = normalize(response, userSchema);

    yield put(sagaActions.updateUserSuccess(normalizedResponse));
  } else {
    yield put(
      handleError(
        error,
        sagaActions.updateUserFailed(_.isEmpty(error) ? {} : error.response.data.errors),
      ),
    );
  }
}

function* getUserSaga(action): any {
  yield put(sagaActions.getUserPending());

  const [error, response] = yield (yield TeammoApi(yield select())).users.show(
    action.payload.userId,
  );
  if (response) {
    const normalizedResponse = normalize(response, userSchema);

    yield put(sagaActions.getUserSuccess(normalizedResponse));
    if (action.payload.redirectDashboard) {
      history.push('/dashboard');
    }
    return normalizedResponse.entities.users[normalizedResponse.result];
  }
  history.push('/login');
  yield put(
    handleError(error, sagaActions.getUserFailed(_.isEmpty(error) ? {} : error.response.data.errors)),
  );
  return null;
}

// function* getAllUsersSaga(action): any {
//   yield put(
//     sagaActions.getAllUsersPending(action.payload.compile ? action.payload.pagination : {}),
//   );
//   yield put(loadingStart());

//   const paginationObject = action.payload.compile
//     ? compilePaginationObject(yield select((state) => state.users.pagination))
//     : action.payload.pagination;

//   const [error, response] = yield (yield TeammoApi(yield select())).users.list(
//     paginationObject,
//   );

//   if (response) {
//     const normalizedResponse = normalize(response, userListSchema);

//     yield put(
//       sagaActions.getAllUsersSuccess(normalizedResponse, response.meta),
//     );
//     yield put(loadingFinish());
//   } else {
//     yield put(
//       error,
//       sagaActions.getAllUsersFailed(_.isEmpty(error) ? {} : error.response.data.errors),
//     );
//   }
// }

/* ********************************* SAGA WATCHERS ********************************* */

function* createUserSagaWatcher(): any {
  yield takeLatest(types.CREATE_USER_REQUESTED, createUserSaga);
}

function* updateUserSagaWatcher(): any {
  yield takeLatest(types.UPDATE_USER_REQUESTED, updateUserSaga);
}

function* getUserSagaWatcher(): any {
  yield takeEvery(types.GET_USER_REQUESTED, getUserSaga);
}

// function* getAllUsersSagaWatcher(): any {
//   yield takeEvery(types.GET_ALL_USERS_REQUESTED, getAllUsersSaga);
// }

export default function* root(): any {
  yield all([
    createUserSagaWatcher(),
    updateUserSagaWatcher(),
    getUserSagaWatcher(),
    // getAllUsersSagaWatcher(),
  ]);
}
